<template>
  <div style="width: 100%; height: 100%; overflow: hidden">
    <!-- 加载动画 -->
    <!-- <div id="loader"></div> -->
    <div class="bg"></div>
    <div class="bg-color"></div>
    <div class="bg-img-bottom"></div>
    <!--  ref="appRef" :class="{ pageisScale: isScale }" -->
    <div class="container" ref="appRef" :class="{ pageisScale: isScale }">
      <div class="head-top d-flex">
        <div class="head-location d-flex">
          <!-- 东华关闭天气显示 dom -->
          <span class="loca nomalFont">徐州</span>
          <div class="wether d-flex nomalFont">
            <img src="../../assets/wether.png" alt="" /><span>{{
              wetherData
            }}</span>
          </div>
          <div class="wendu nomalFont">
            <span>{{ wendu }}℃</span>
          </div>
        </div>
        <div class = "d-flex">
          <img src="../../assets/logo26.png" />
          <span class="title nomalFont">能源管理驾驶舱</span>
        </div>

        <div class="head-time d-flex">
          <span class="data nomalFont">{{ yearData }}</span>
          <span class="week nomalFont">{{ weekData }}</span>
          <span class="timer nomalFont">{{ timeData }}</span>
        </div>
      </div>
      <div class="cont-div">
        <!-- 左侧 -->
        <div class="left-cont">
          <!-- 碳排放量 -->
          <div class="emissions">
            <div class="pubic-top d-flex">
              <div class="img-bg img-bg-nums">
                <img src="../../assets/rive.png" alt="" class="rive" />
              </div>
              <div class="text-bg">
                <span class="nomalFont">用能趋势量(标准煤)</span>
              </div>
            </div>
            <!-- <div id="emissions" style="height: calc(100% - 80px)"></div> -->
            <carbonEmission
              :chartData1="chartData1"
              :chartData2="chartData2"
              :monthData="xData"
              :flag="flag"
              style="height: calc(100% - 80px)"
            ></carbonEmission>
          </div>
          <!-- 碳排放强度 -->
          <div class="emissions">
            <div class="pubic-top d-flex">
              <div class="img-bg img-bg-nums">
                <img src="../../assets/rive.png" alt="" class="rive" />
              </div>
              <div class="text-bg">
                <span class="nomalFont">用能耗费</span>
              </div>
            </div>
            <emissionIntensity
              style="height: calc(100% - 80px)"
              :intensityxData="xData"
              :intensityFirstData="intensityFirstData"
              :intensitySecondData="intensitySecondData"
            ></emissionIntensity>
          </div>
          <!-- 重点设备排放量 -->
          <div class="emissions" style="position: relative">
            <div class="pubic-top d-flex">
              <div class="img-bg img-bg-import">
                <img src="../../assets/rive.png" alt="" class="rive" />
              </div>
              <div class="text-bg">
                <span class="nomalFont">重点区域用能排名</span>
              </div>
            </div>
            <span id="imporPoint">{{ dataTimes }}</span>
            <importEmission
              :importantxData="importantxData"
              :turnData="turnData"
              :brokenData="brokenData"
              :rawData="rawData"
              :coalMillData="coalMillData"
              style="height: calc(100% - 80px)"
            >
            </importEmission>
          </div>
        </div>
        <!-- 中间 -->
        <div class="center-cont">
          <topCommon :getTopCommonDatas="getTopCommonDatas"></topCommon>
          <topmain
            :middata="middata"
            :jinanDatasTrue="jinanData"
            :ziboDataTrue="ziboData"
            :outBuyPower="outBuyPower"
            :objNews="objNews"
          ></topmain>
        </div>
        <!-- 右侧 -->
        <div class="right-cont">
          <!-- 碳排放量 -->
          <div class="emissions emissionsSpcal">
            <div class="pubic-top d-flex">
              <div class="img-bg img-bg-trade">
                <img src="../../assets/rive.png" alt="" class="rive" />
              </div>
              <div class="text-bg">
                <!--span class="nomalFont">碳履约/碳交易</span-->
                <span class="nomalFont">总量/总费用</span>
              </div>
            </div>
            <trade
              :yingyue="yingyue"
              :income="incomeMoney"
              :tradexData="tradexData"
              :ccerData="ccerData"
              :quotaData="quotaData"
            ></trade>
          </div>
          <!-- 碳排放量 -->
          <div class="emissions emissionsSpcals">
            <div class="pubic-top d-flex">
              <div class="img-bg img-bg-ccer">
                <img src="../../assets/rive.png" alt="" class="rive" />
              </div>
              <div class="text-bg">
                <span class="nomalFont">报警信息</span>
              </div>
            </div>
            <ccer :tableData="tableData"></ccer>
          </div>
          <!-- 碳排放量 -->
          <div class="emissions emissionsSpcals">
            <div class="pubic-top d-flex">
              <div class="img-bg img-bg-ccercount">
                <img src="../../assets/rive.png" alt="" class="rive" />
              </div>
              <div class="text-bg">
                <span class="nomalFont">设备状态统计</span>
              </div>
            </div>
            <countccer :ccerCountData="ccerCountData"></countccer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import carbonEmission from "../../components/left/carbonEmission.vue";
import emissionIntensity from "../../components/left/emissionIntensity.vue";
import importEmission from "../../components/left/importEmission.vue";
import topCommon from "../../components/mid/topCommon.vue"
import topmain from "../../components/mid/topmain.vue"
import ccer from "../../components/right/ccer.vue"
import countccer from "../../components/right/countccer.vue"
import trade from "../../components/right/trade.vue"

import { getEmissionData, getStrengthData, getEvidenceData, getTopCommonData, getTopMainData, getDealData, getChildGroup5SumApi, getCenterDataForJApi, getCCERListApi, getCCERDataApi, RData, gerOutBuyPower } from "@/api/api";
export default {
  name: 'index',
  components: { carbonEmission, emissionIntensity, importEmission, topCommon, ccer, countccer, trade, topmain },
  data () {
    return {
      test: '',
      yearData: '',// 日期
      weekData: '', //周几
      timeData: '', //时间
      wetherData: '', //天气
      wendu: '',//温度
      // * 定时函数
      drawTiming: null,
      isScale: true,
      /* 当前时间 */
      date: new Date(),

      // 排放量
      monthData: {}, // x坐标轴
      xData: [],//'2月', '3月', '4月', '5月'
      chartData1: {
        "化石燃料": [0, 0, 0, 0],
        "替代燃料": [0, 0, 0, 0],
        "原料碳酸盐": [0, 0, 0, 0],
        "非燃料碳煅烧": [0, 0, 0, 0],
        "购入电力": [0, 0, 0, 0],
        "购入热力": [0, 0, 0, 0]
      },
      chartData2: {
        "化石燃料": [0, 0, 0, 0],
        "替代燃料": [0, 0, 0, 0],
        "原料碳酸盐": [0, 0, 0, 0],
        "非燃料碳煅烧": [0, 0, 0, 0],
        "购入电力": [0, 0, 0, 0],
        "购入热力": [0, 0, 0, 0]
      },
      tipName: {
        "化石燃料燃烧产生的排放量": "化石燃料",
        "替代燃料和协同处置的废弃物中非生物质碳的燃烧产生的排放量": "替代燃料",
        "原料碳酸盐分解产生的排放量": "原料碳酸盐",
        "生料中非燃料碳煅烧产生的排放量": "非燃料碳煅烧",
        "净购入使用的电力对应的排放量": "购入电力",
        "净购入使用的热力对应的排放量": "购入热力",
      },

      // 排放强度
      intensityxData: [], //x轴
      intensityFirstData: [], //碳强度一号线
      intensitySecondData: [], //碳强度二号线
      // 重点设备排放量
      importantxData: ['2月', '3月', '4月', '5月'], //x轴
      turnData: [25, 32, 44, 22], //回转窑
      brokenData: [32, 48, 22, 50], //破碎机
      rawData: [12, 24, 36, 48], //原料磨
      coalMillData: [11, 22, 22, 33], // 磨煤机
      //碳履约/碳交易
      tradexData: [], //x轴
      ccerData: [], //ccer数据
      quotaData: [], //配额数据
      // CCER 滚动tableData
      tableData: [],
      ccerCountData: {
        approved: 15, // 已审定数量
        approval: 32, //审定总数量
        hasBeenFiled: 22, //已备案数量
        filing: 22, //备案总数量
        detected: 10, //已检测数量
        detect: 47, //检测总数量
        certified: 20, //已核证数量
        certifications: 30 //核证总数量
      },
      flag: false,
      dataTime: '2022-08-31 9:10',
      // mid 点击数据
      middata: {
        firstOut: 0, //一号线
        secondOut: 0,// 二号线
      },
      // mid 底部徐州万华数据
      ziboData: {
        monthOut: 0,
        monthStrength: 0
      },
      jinanData: {
        monthOut: 0,
        monthStrength: 0
      },
      // mid 上方四组数据集合
      getTopCommonDatas: {},
      outBuyPower: 0, // mid 外购电力
      yingyue: null, //盈余额
      incomeMoney: null, //营业额
      dataTimes: null, // 时分秒
      objNews: {}
    }
  },
  created () {
    // 初始化时间
    let that = this
    setInterval(that.getTime, 1000)
    this.getWether(); // 初始化天气 东华无内网 需关闭
    this.loadEmissionData(); //碳排放量
    this.loadStrengthData(); //碳排放强度
    // this.loadEvidenceData();//重点设备排放量
    this.loadTopMainData();//mid 下方点击弹出数据
    this.loadTopCommonData();
    this.loadDealData();
    this.loadCCERData();
    this.gerOutBuyPowerApi() //获取外购电力值
    this.getCenterDataForJ() //获取其他值
    this.getChildGroup5Sum()// 获取年度累计耗电量

    setInterval(function () {
      that.loadEmissionData(); //碳排放量
      that.loadStrengthData(); //碳排放强度
      that.loadTopMainData();//mid 下方点击弹出数据
      that.loadTopCommonData();
      that.loadDealData();
      that.loadCCERData();
      that.gerOutBuyPowerApi() //获取外购电力值
      that.getCenterDataForJ() //获取其他值
      that.getChildGroup5Sum()// 获取年度累计耗电量
    }, 600000)    //600000

    setInterval(function () {
      location.reload();
    }, 86400000)
  },
  mounted () {
    this.setX() //设置月份
    // 初始化屏幕
    if (!this.isScale) {
      return
    }
    this.calcRate()
    window.addEventListener('resize', this.resizeScreen)

  },

  methods: {
    // 碳排放量
    loadEmissionData () {
      //this.monthData = {}
      let that = this;
      let date = new Date();
      date.setMonth(date.getMonth() - 3);  // 3
      let tempm = {}
      for (let i = 0; i < 4; i++) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1
        tempm[year + '-' + month] = i
        date.setMonth(date.getMonth() + 1);
      }
      //this.monthData = tempm
      //产线1
      getEmissionData({ id: 23 }).then(res => {
        if (res != null && res.data != null && res.data.code != null
          && res.data.code == 200 && res.data.data != null && res.data.data.length > 0) {

          let resData = res.data.data
          let mapData = resData.filter(obj => {
            return obj.tallymonth >= date.getMonth() - 3
          })
          mapData.map(obj => {
            this.chartData1[that.tipName[obj.projectname]][tempm[obj.tallyyear + '-' + obj.tallymonth]] = this.NumberFormat(Math.round(obj.discharge) / 10000, 2)
          })
        }
      })
      //console.log(this.chartData1)
      //产线2
      getEmissionData({ id: 28 }).then(res => {
        if (res != null && res.data != null && res.data.code != null && res.data.code == 200 && res.data.data != null && res.data.data.length > 0) {
          let resData = res.data.data
          let mapData = resData.filter(obj => {
            return obj.tallymonth >= date.getMonth() - 3
          })
          mapData.map(obj => {
            that.chartData2[that.tipName[obj.projectname]][tempm[obj.tallyyear + '-' + obj.tallymonth]] = this.NumberFormat(Math.round(obj.discharge) / 10000, 2)
          })
        }
      })
      this.flag = true
    },
    NumberFormat (num, deci, is) {
      if (!num)
        return 0;
      if (!this.isNumberStr(num))
        return 0;
      if (!is) {
        return parseFloat(Number(num).toFixed(deci));
      } else {
        return Number(num).toFixed(deci);
      }
    },
    isNumberStr (str) {
      return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(str)
    },
    /* 格式化日期时间 */
    dateFormat (time) {
      let date = new Date(time);
      let year = date.getFullYear();
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
    },
    // 初始化天气
    getWether () {
      // https://apis.juhe.cn/simpleWeather/query?city=徐州&key=fce651c064302c935e3b85fa66dda2df
      let url = 'https://api.seniverse.com/v3/weather/now.json?key=StGG5kFtkb4-viVJ0&location=徐州&language=zh-Hans&unit=c';
      Axios.get(
        url
      ).then((response) => {
        //console.log(response)
        if (response && response.status === 200) {
          this.wetherData = response.data.results[0].now.text
          this.wendu = response.data.results[0].now.temperature
          // this.wendu = response.data.data.forecast[0].low + '-' + response.data.data.forecast[0].high
        }
      }).catch((error) => {
        // this.$message(error);
        console.log(error)
      })
    },
    // 获取当前时间
    getTime () {
      var myDate = new Date();
      var myYear = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
      var myMonth = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
      var myToday = myDate.getDate(); //获取当前日(1-31)
      var myDay = myDate.getDay(); //获取当前星期X(0-6,0代表星期天)
      var myHour = myDate.getHours(); //获取当前小时数(0-23)
      var myMinute = myDate.getMinutes(); //获取当前分钟数(0-59)
      var mySecond = myDate.getSeconds(); //获取当前秒数(0-59)
      var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

      this.yearData = myYear + '-' + this.fillZero(myMonth) + '-' + this.fillZero(myToday)
      this.weekData = week[myDay]
      this.timeData = this.fillZero(myHour) + ':' + this.fillZero(myMinute) + ':' + this.fillZero(mySecond)
      this.dataTimes = this.yearData + '  ' + this.timeData
    },
    fillZero (str) {
      var realNum;
      if (str < 10) {
        realNum = '0' + str;
      } else {
        realNum = str;
      }
      return realNum;
    },
    // 初始化屏幕
    calcRate () {
      // * 默认缩放值
      const scale = {
        width: '1',
        height: '1',
      }
      // * 设计稿尺寸（px）
      const baseWidth = 1920
      const baseHeight = 1080

      // * 需保持的比例（默认1.77778）
      const baseProportion = parseFloat((baseWidth / baseHeight).toFixed(5))
      const appRef = this.$refs["appRef"]
      if (!appRef) return
      // 当前宽高比
      const currentRate = parseFloat((window.innerWidth / window.innerHeight).toFixed(5))
      if (appRef) {
        if (currentRate > baseProportion) {
          // 表示更宽
          scale.width = ((window.innerHeight * baseProportion) / baseWidth).toFixed(5)
          scale.height = (window.innerHeight / baseHeight).toFixed(5)
          appRef.style.transform = `scale(${scale.width}, ${scale.height}) translate(-50%, -50%)`
        } else {
          // 表示更高
          scale.height = ((window.innerWidth / baseProportion) / baseHeight).toFixed(5)
          scale.width = (window.innerWidth / baseWidth).toFixed(5)
          appRef.style.transform = `scale(${scale.width}, ${scale.height}) translate(-50%, -50%)`
        }
      }
    },
    resizeScreen () {
      if (!this.isScale) {
        return
      }
      clearTimeout(this.drawTiming)
      this.drawTiming = setTimeout(() => {
        this.calcRate()
      }, 200)
    },

    setX () {
      let date = new Date();
      date.setMonth(date.getMonth() - 3);
      for (let i = 0; i < 4; i++) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        this.monthData[year + '-' + month] = i;
        date.setMonth(date.getMonth() + 1);
      }
      for (var val in this.monthData) {
        this.xData[this.monthData[val]] = val.split('-')[1] + "月";
      }
    },

    //碳排放强度
    loadStrengthData () {
      let that = this;
      this.intensityFirstData = [];

      let date1 = new Date();
      date1.setMonth(date1.getMonth() - 3);  // 3
      let tempm = {}
      for (let i = 0; i < 4; i++) {
        let year = date1.getFullYear();
        let month = date1.getMonth() + 1
        tempm[year + '-' + month] = i
        date1.setMonth(date1.getMonth() + 1);
      }

      //产线1
      getStrengthData({ id: 23 }).then(res => {
        let tmp = [0, 0, 0, 0];
        if (res != null && res.data != null && res.data.code != null && res.data.code == 200 && res.data.data != null && res.data.data.length > 0) {
          let resData = res.data.data
          let date = new Date()
          let mapData = resData.filter(obj => {
            return obj.tallymonth >= date.getMonth() - 3
          })
          mapData.map(obj => {
            tmp[tempm[obj.tallyyear + '-' + obj.tallymonth]] = this.NumberFormat(obj.strenth, 2);
          })
        } else {
          this.$message(res.data.message)
        }
        that.intensityFirstData = tmp;
      })
      //产线2
      this.intensitySecondData = [];
      getStrengthData({ id: 28 }).then(res => {
        let tmp = [0, 0, 0, 0];
        if (res != null && res.data != null && res.data.code != null && res.data.code == 200 && res.data.data != null && res.data.data.length > 0) {
          let resData = res.data.data
          let date = new Date()
          let mapData = resData.filter(obj => {
            return obj.tallymonth >= date.getMonth() - 3
          })
          mapData.map(obj => {
            tmp[tempm[obj.tallyyear + '-' + obj.tallymonth]] = this.NumberFormat(obj.strenth, 2);
          })
        }
        that.intensitySecondData = tmp;
      })

    },
    //重点设备碳排放
    loadEvidenceData () {
      let that = this;
      getEvidenceData().then();
    },
    //topcommon
    loadTopCommonData () {
      let that = this;
      getTopCommonData({}).then(res => {
        if (res != null && res.data != null && res.status == 200 && res.data.code == 200) {

          this.getTopCommonDatas = res.data.data
          this.yingyue = res.data.data.peieyingque
          this.incomeMoney = res.data.data.chanliangjiaoshangyue
        }
      });
    },
    //topMain
    loadTopMainData () {
      let that = this
      // 一号线排放量
      getEmissionData({ id: 23 }).then(res => {
        if (res != null && res.data != null && res.data.code != null && res.data.code == 200 && res.data.data != null && res.data.data.length > 0) {

          let arr1 = []
          let arr2 = []
          res.data.data.map(obj => {
            if (obj.projectname == '净购入使用的热力对应的排放量') {
              arr2.push(this.NumberFormat(Math.round(obj.discharge) / 10000, 2))
            } else {
              arr1.push(this.NumberFormat(Math.round(obj.discharge) / 10000, 2))
            }
          })
          let firstOut = arr1.reduce(function (a, b) {
            return a + b;
          });
          let firstOut2 = arr2.reduce(function (a, b) {
            return a + b;
          });
          this.middata.firstOut = (firstOut - firstOut2).toFixed(2)
        }
      })
      // 二号线排放量
      getEmissionData({ id: 28 }).then(res => {
        if (res != null && res.data != null && res.data.code != null && res.data.code == 200 && res.data.data != null && res.data.data.length > 0) {


          let arr1 = []
          let arr2 = []
          res.data.data.map(obj => {
            if (obj.projectname == '净购入使用的热力对应的排放量') {
              arr2.push(this.NumberFormat(Math.round(obj.discharge) / 10000, 2))
            } else {
              arr1.push(this.NumberFormat(Math.round(obj.discharge) / 10000, 2))
            }
          })
          let firstOut = arr1.reduce(function (a, b) {
            return a + b;
          });
          let firstOut2 = arr2.reduce(function (a, b) {
            return a + b;
          });
          this.middata.secondOut = (firstOut - firstOut2).toFixed(2)

        }
      })
      // 徐州万华 月碳排放量
      getEmissionData({ id: 34 }).then(res => {
        if (res != null && res.data != null && res.data.code != null && res.data.code == 200 && res.data.data != null && res.data.data.length > 0) {

          let data = new Date()
          let nowMoth = data.getMonth() + 1
          let resData = res.data.data
          let mapData = resData.filter(obj => {
            return obj.tallymonth == nowMoth
          })
          let ziboArr = []
          mapData.map(res2 => {
            ziboArr.push(this.NumberFormat(Math.round(res2.discharge) / 10000, 2))
          })
          if (ziboArr != null && ziboArr.length > 0) {
            var ziboDatas = ziboArr.reduce(function (a, b) {
              return a + b;
            });
            this.ziboData.monthOut = ziboDatas.toFixed(2)
          } else {
            this.ziboData.monthOut = 0
          }

        }
      })
      // 济南万华 月碳排放量
      getEmissionData({ id: 35 }).then(res => {
        if (res != null && res.data != null && res.data.code != null && res.data.code == 200 && res.data.data != null && res.data.data.length > 0) {

          let data = new Date()
          let nowMoth = data.getMonth() + 1
          let resData = res.data.data
          let mapData = resData.filter(obj => {
            return obj.tallymonth == nowMoth
          })
          let ziboArr = []
          mapData.map(res2 => {
            ziboArr.push(this.NumberFormat(Math.round(res2.discharge) / 10000, 2))
          })
          if (ziboArr != null && ziboArr.length > 0) {
            var jinanDatas = ziboArr.reduce(function (a, b) {
              return a + b;
            });
            this.jinanData.monthOut = jinanDatas.toFixed(2)
          } else {
            this.jinanData.monthOut = 0
          }

        }
      })
      // 徐州万华 月碳强度
      getStrengthData({ id: 34 }).then(res => {
        let tmp = [0, 0, 0, 0,];
        if (res != null && res.data != null && res.data.code != null && res.data.code == 200 && res.data.data != null && res.data.data.length > 0) {
          res.data.data.map(obj => {
            let arr = []
            arr.push(this.NumberFormat(obj.strenth, 2))
            let sumStrength = arr.reduce(function (a, b) {
              return a + b
            })
            this.ziboData.monthStrength = sumStrength.toFixed(2)
          })
        }
      })
      // 济南万华 月碳强度
      getStrengthData({ id: 35 }).then(res => {
        let tmp = [0, 0, 0, 0,];
        if (res != null && res.data != null && res.data.code != null && res.data.code == 200 && res.data.data != null && res.data.data.length > 0) {
          res.data.data.map(obj => {
            let arr = []
            arr.push(this.NumberFormat(obj.strenth, 2))
            let sumStrength = arr.reduce(function (a, b) {
              return a + b
            })
            this.jinanData.monthStrength = sumStrength.toFixed(2)
          })
        }
      })

    },
    //loadDealData
    loadDealData () {
      let that = this;
      getCCERListApi().then(res => {
        if (res != null && res.data != null && res.status == 200 && res.data.code == 200) {
          this.tableData = res.data.data.list
          this.ccerCountData = res.data.data.one
          // debugger
        }
      });
    },
    //ccer and ccer project
    loadCCERData () {
      let that = this;
      getCCERDataApi().then(res => {

        if (res != null && res.data != null && res.status == 200 && res.data.code == 200) {
          let resData = []
          for (var i = 0; i < res.data.data.length; i++) {
            resData.unshift(res.data.data[i]);
          }
          let tradexDatas = []
          let ccerDatas = []
          let quotaDatas = []
          resData.map(res => {
            tradexDatas.push(res.daytime.slice(5, 10))
            ccerDatas.push(res.ccerprice)
            quotaDatas.push(res.quotaprice)
          })
          this.tradexData = tradexDatas
          this.ccerData = ccerDatas
          this.quotaData = quotaDatas
        }
      });
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeScreen)
    },
    // 获取外购电力值
    gerOutBuyPowerApi () {
      gerOutBuyPower().then(res => {

        if (res != null && res.data != null && res.status == 200 && res.data.code == 200) {
          this.outBuyPower = res.data.data.aval
        }
      })
    },
    // 获取 年度累计耗电量
    getChildGroup5Sum () {
      getChildGroup5SumApi().then(res => {
        if (res != null && res.data != null && res.status == 200 && res.data.code == 200) {
          let resData = res.data.data
          resData.map(res => {
            if (res.id == "83abe8921a374c56927bf9a4527423cd") {
              // this.objNews.zibodianhao = 12
              this.objNews.zibodianhao = res.allsum
            } else if (res.id == "280f8fa7707c4cef8e6f1d1792e719a8") {
              // this.objNews.jinandianhao = 15
              this.objNews.jinandianhao = res.allsum
            } else {
              this.objNews.zibodianhao = 0
              this.objNews.jinandianhao = 0
            }
          })
        }
      })
    },
    // 获取其他接口信息
    getCenterDataForJ () {
      let tempsssss = this.objNews
      getCenterDataForJApi().then(res => {
        if (res != null && res.data != null && res.status == 200 && res.data.code == 200) {

          let tempss = {}
          res.data.data.map(obj => {
            if (obj.id == "38") {
              tempss.jieshengbiaomei = obj.a
            }
            if (obj.id == "39") {
              tempss.guangfufadian = obj.a
            }
            if (obj.id == "40") {
              tempss.ffadianN = obj.a
            }
            if (obj.id == "41") {
              tempss.sfadiann = obj.a
            }
            if (obj.id == "42") {
              tempss.yurefadian = obj.a
            }
            // 年度累计耗电量
            /* if (obj.id == "43") {
              // tempss.zibodianhao = obj.a
              //tempss.zibodianhao = 0
            } */
            if(tempsssss.zibodianhao != null) {
              tempss.zibodianhao = tempsssss.zibodianhao
            }else
              tempss.zibodianhao = 0
            /* if (obj.id == "44") {
              // tempss.jinandianhao = obj.a
              //tempss.jinandianhao = 0
            } */
            if(tempsssss.jinandianhao != null) {
              tempss.jinandianhao = tempsssss.jinandianhao
            }else
              tempss.jinandianhao = 0
            if (obj.id == "45") {
              tempss.jiemei = obj.a
            }
          })
          this.objNews = tempss
        }
      })
    }

  }
}
</script>

<style scoped>
.bg {
  background: url(../../assets/bg5.png) no-repeat center center;
  position: absolute;
  top: 6.5%;
  right: 20px;
  left: 24%;
  bottom: 0;
  width: 52%;
  height: 100%;
  background-size: 100%;
  z-index: 1;
}
.emissionsSpcals {
  overflow: hidden;
}
#imporPoint {
  position: absolute;
  right: 15px;
  top: 80px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreen/index.vue